const pathname = window.location.pathname;
const liveRoute = pathname === "/live" || pathname.startsWith("/live/")
  || pathname === "/try" || pathname.startsWith("/try/");
const adminRoute = pathname === "/admin/invitations" || pathname.startsWith("/admin/invitations/");

async function loadLiveDemo() {
  await import("./live-demo/main");
}

async function loadShowcase() {
  await import("./showcase/main");
}

async function loadInvitationAdmin() {
  await import("./admin/main");
}

if (adminRoute) {
  void loadInvitationAdmin();
} else if (liveRoute) {
  void loadLiveDemo();
} else {
  void loadShowcase();
}
